import React from "react";
import InvoiceView from "../views/users/InvoiceView";

const Invoice: React.FC = () => {
    return <div><InvoiceView /></div>;
};

export default Invoice;